export enum ContactRequestType {
  SaveSolution = "SaveSolution",
  RequestForPrint = "RequestForPrint",
  RequestForQuote = "RequestForQuote",
  RequestForSample = "RequestForSample",
  TalkToExpert = "TalkToExpert",
  ContactUs = "ContactUs",
  DesignIt = "DesignIt",
}